<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BuildingAreaPanel from '../../../../../../buildings/components/panels/BuildingAreaPanel.vue'

import { Building } from '../../../../../../buildings/models/building'
import { SiteID } from '../../../../../../sites/models/site'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { siteId, building } = defineProps<{
  siteId: SiteID
  building: Building
}>()
</script>

<template>
  <BuildingAreaPanel :site-id="siteId" :building="building" />
</template>
